import { RefabricProURL } from "../index";
import { ApiResponse } from "../HttpClient";
import { IDesignGetDesignRequest } from "api/design/design.type";
import { ISiteImagesPreviewResponse, ISiteImagesResponse } from "api/statics/statics.type";
import { SITE_IMAGES_PREVIEW_PATH } from "api/statics/sitePreviewPath";

export default {
  async getStyleList(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/style_list", {});
  },
  async getPatternList(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/pattern_list", {});
  },
  async getTrainTypes(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/train_type", {});
  },
  async getTrainStatuses(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/train_status", {});
  },
  async getFocusTypes(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/focus_prompts", {});
  },
  async getDiscover(params: IDesignGetDesignRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/explorer", { params });
  },
  async getModelList(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/photoshooting_model_list", {});
  },
  async getAnimateTemplateList(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/animate_template_list", {});
  },
  async getPoseList(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/pose_prompt_list", {});
  },
  async getTemplateShoes(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/template_shoes", {});
  },
  async getTemplateGarments(params: { type: "top" | "low" }): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/template_garments", { params });
  },
  async getKidTemplateShoes(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/kid_template_shoes", {});
  },
  async getKidTemplateGarments(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/kid_template_garments", {});
  },
  async getLoginImages(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get("statics/login_images", {});
  },
  async getSiteImages(): Promise<ApiResponse<ISiteImagesResponse>> {
    return await RefabricProURL.get("statics/site_images", {});
  },
  // A bad or expired token answers 401, which this path REJECTS instead of logging out — see the
  // site-images exemption in HttpClient's 401 branch.
  async getSiteImagesPreview(token: string): Promise<ApiResponse<ISiteImagesPreviewResponse>> {
    return await RefabricProURL.get(SITE_IMAGES_PREVIEW_PATH, { headers: { "X-Site-Preview": token } });
  },
};
